import { ArticleShare as ArticleShareComponent } from '@bridebook/web/app-basic/components/articles/share/article-share.component';
import { ArticleShareProps } from '@bridebook/web/app-basic/components/articles/share/article-share.types';
import { getArticle } from '@bridebook/web/app-basic/lib/article/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { FC, memo } from 'react';

const ArticleShareContainer: FC<ArticleShareProps> = ({ pinImage }) => {
  const article = useSelector(getArticle);

  if (!article) return null;

  return <ArticleShareComponent article={article} pinImage={pinImage} />;
};

export const ArticleShare = memo(ArticleShareContainer);
